import { css } from '@emotion/react';

import { Img } from '@zapier/design-system';
import { Invitation } from '@zapier/authentication';
import { useTranslations } from 'next-intl';

type Props = {
  invitation: Invitation;
};

const rootStyle = css`
  align-items: center;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  justify-content: center;
`;

export function InvitationTitle({ invitation }: Props) {
  const t = useTranslations('invitation-title');

  return (
    <div css={rootStyle}>
      <span>{t('title', { accountName: invitation.account.name })}</span>
      {invitation.account?.logoUrl && (
        <Img
          alt={t('account-icon-alt')}
          aria-hidden={true}
          src={invitation.account?.logoUrl}
          width={32}
        />
      )}
    </div>
  );
}
